module.exports = __webpack_public_path__ + "static/console_default.f6cd4a9f.png";